import { View } from "extensions/marionette";
import Radio from "backbone.radio";
import moment from "moment";

import tokenObserver from "./tokenObserver.jst";
import "./tokenObserver.scss";

export const TokenObserver = View.extend({
    template: tokenObserver,
    ui: {
        expires_in: ".expires_in"
    },
    initialize() {
        this.expires_in = 0;
    },
    updateTokenExpiration() {
        const newExpiration = Radio.channel("security").request("token:get:expiration");
        
        if (newExpiration === 0) {
            this.ui.expires_in.text("expired");
        } else {
            this.expires_in = newExpiration;
            this.ui.expires_in.text(moment(this.expires_in - new Date()).format("mm:ss"));
        }
        
        setTimeout(() => {
            window.requestAnimationFrame(() => {
                if (this.isDestroyed()) { return; }
                this.updateTokenExpiration();
            });
        }, 1000);
    },
    onRender() {
        this.updateTokenExpiration();
    }
});
